import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20with%20warm%20golden%20amber%20and%20soft%20coral%20tones%20featuring%20dreamy%20gradient%20background%2C%20subtle%20comic%20panel%20line%20elements%20blended%20ethereally%2C%20bottom%20section%20with%20gentle%20abstract%20shapes%20suggesting%20characters%20immersed%20in%20reading%2C%20top%20section%20airy%20and%20open%20with%20soft%20diffused%20light%20beams%2C%20modern%20digital%20art%20style%2C%20editorial%20composition%2C%20harmonious%20warm%20color%20palette%2C%20elegant%20minimalist%20aesthetic%2C%20no%20text%20no%20letters%2C%20pure%20visual%20art&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
        alt="韩漫网站 - 免费韩国漫画在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight mb-5">
          韩漫免费在线观看
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed mb-8">
          收录海量好看的韩国漫画大全，提供流畅的下拉式阅读体验。<br className="hidden sm:block" />
          每日更新热门连载，完全免费，随时随地畅享韩漫世界。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm md:text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即开始阅读
          </Link>
          <Link
            to="/category/all"
            className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white font-medium rounded-full text-sm md:text-base hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer border border-white/20"
          >
            查看排行榜
          </Link>
        </div>
      </div>
    </section>
  );
}